import { InView } from '../../elements/utils/inViewObserver/InView'
import { handleInViewChange } from './helpers/handleInViewChange'

export const NoAdInView = ({ data }) => {
  const onViewChange = handleInViewChange(data)

  return <InView onChange={onViewChange} triggerOnce />
}
